<template>
  <div>
    <h3 class="pt-3">
      Pre-Screened--{{ tableHeaderDisplayName }}
      <app-tooltip right>
        <template #activator="{ on }">
          <sup><v-icon small class="material-icons-round" v-on="on">info</v-icon></sup>
        </template>
        <span>Patients in a status of Matched, Enrolled, Not Consented, Not Eligible</span>
      </app-tooltip>
    </h3>
    <v-data-table
      class="dark-headers"
      :headers="headers"
      :items="details"
      :loading="loading"
      :options.sync="options"
      :footer-props="{
        itemsPerPageOptions: [5, -1]
      }"
      no-data-text="No reasons available"
    >
      <template #item="{ item }">
        <tr>
          <td>{{ statusValueText(item.statusValue) }}</td>
          <td>
            {{ getStatusDetail(item) }}
            <span
              v-show="item.statusDetail.length > statusDetailLimit"
              class="link"
              @click="item.showMore = !item.showMore"
              >Show {{ item.showMore ? 'Less' : 'More' }}</span
            >
          </td>
          <td class="text-right">{{ item.count }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { MyActiveOrganization } from '@/helpers/my-account-helper'
import trialSummaryService from '@/services/trial-summary-service'
import { TrialIdentificationStatusValue } from '@/helpers/trial-helper'
import _ from 'lodash'

export default {
  props: {
    trialId: { type: String, default: null },
    tableHeaderDisplayName: { type: String, default: null }
  },
  data() {
    return {
      statusDetailLimit: 90,
      headers: [
        {
          text: 'Status',
          sortable: true,
          value: 'statusValue'
        },
        {
          text: 'Reasons',
          sortable: true,
          value: 'statusDetail'
        },
        {
          text: 'Count',
          align: 'right',
          sortable: true,
          value: 'count'
        }
      ],
      options: {
        page: 1,
        sortBy: ['statusValue', 'count'],
        sortDesc: [false, true],
        itemsPerPage: 5
      },
      details: [],
      loading: true
    }
  },
  computed: {
    orgId() {
      return MyActiveOrganization.id
    }
  },
  watch: {
    async trialId() {
      await this.getStatusCounts()
    },
    async orgId() {
      await this.getStatusCounts()
    }
  },
  created() {
    this.getStatusCounts()
  },
  methods: {
    async getStatusCounts() {
      this.loading = true
      try {
        let { data } = await trialSummaryService.listTrialSummaryStatusCounts({
          trialId: this.trialId,
          orgId: this.orgId
        })
        this.details = _.map(
          _.filter(data, it => it.count > 0),
          function(it) {
            it.showMore = false
            return it
          }
        )
      } finally {
        this.loading = false
      }
    },
    getStatusDetail(item) {
      if (!item.showMore) {
        return _.truncate(item.statusDetail, { length: this.statusDetailLimit })
      }
      return item.statusDetail
    },
    statusValueText(statusValue) {
      return TrialIdentificationStatusValue[statusValue].text
    }
  }
}
</script>

<style lang="scss" scoped>
.link {
  color: var(--v-anchor-base);
  cursor: pointer;
}
</style>
